import call from "../../../../service/http";
import firmbioConstants from "./firmbioConstants";

export default {
  state: {
    firmBio: [],
  },
  mutations: {
    SET_FIRM_BIO: (state, payload) => {
      state.firmBio = payload;
    },
  },
  getters: {
    firmBio: (state) => state.firmBio,
  },
  actions: {
    getFirmBio: ({ commit }, params) => {
      commit("SET_ALERT", null);
      commit("SET_LOADING", true, { root: true });
      call("get", firmbioConstants.getfirmBio, null, { params })
        .then((res) => {
          commit("SET_FIRM_BIO", res.data.data);
          commit("SET_LOADING", false, { root: true });
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "error",
            message: err.response.data.message,
          });
        });
    },

    saveFirmBio: ({ commit }, data) => {
      commit("SET_ALERT", null);
      commit("SET_LOADING", true, { root: true });
      call("post", firmbioConstants.firmBio, data)
        .then((res) => {
          commit("SET_LOADING", false, { root: true });
          Event.$emit("on-save-firm-bio", res.data.data);
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "error",
            message: err.response.data.message,
          });
        });
    },

    updateFirmBio: ({ commit }, data) => {
      commit("SET_ALERT", null);
      commit("SET_LOADING", true, { root: true });
      call("post", firmbioConstants.update, data)
        .then(() => {
          Event.$emit("application-checklist");
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "error",
            message: err.response.data.message,
          });
        });
    },
  },
};
